import { getAnnouncementBanner, getSystemDowntime } from "@/services/commerceService/common";
import { fetch as fetchCountries } from "@/services/commerceService/countries";
import {
  getAnnouncementBanner as getUnauthAnnouncementBanner,
  getSystemDowntime as getUnauthSystemDowntime,
} from "@/services/unauthService/common";

export default {
  namespaced: true,
  state: {
    systemDowntime: null as any,
    announcementBanner: null as any,
    countries: [] as any,
  },
  getters: {
    systemDowntime: (state: any) => state.systemDowntime,
    announcementBanner: (state: any) => state.announcementBanner,
    countries: (state: any) => state.countries,
  },
  mutations: {
    setSystemDowntime(state: any, value: any) {
      state.systemDowntime = value;
    },
    setAnnouncementBanner(state: any, value: any) {
      state.announcementBanner = value;
    },
    setCountries(state: any, value: any) {
      state.countries = value;
    },
  },
  actions: {
    async fetchSystemDowntime({ commit }: any) {
      await getSystemDowntime()
        .then((response: any) => {
          commit("setSystemDowntime", response);
        })
        .catch(() => {
          // do nothing
        });
    },
    async fetchAnnouncementBanner({ commit }: any) {
      await getAnnouncementBanner()
        .then((response: any) => {
          commit("setAnnouncementBanner", response);
        })
        .catch(() => {
          // do nothing
        });
    },
    async fetchUnauthSystemDowntime({ commit }: any) {
      await getUnauthSystemDowntime()
        .then((response: any) => {
          commit("setSystemDowntime", response);
        })
        .catch(() => {
          // do nothing
        });
    },
    async fetchUnauthAnnouncementBanner({ commit }: any) {
      await getUnauthAnnouncementBanner()
        .then((response: any) => {
          commit("setAnnouncementBanner", response);
        })
        .catch(() => {
          // do nothing
        });
    },
    async fetchCountryList({ commit }: any) {
      fetchCountries()
        .then((countries: any) => {
          if (countries && countries.length > 0) {
            commit("setCountries", countries);
          }
        })
        .catch((error: any) => {
          //do nothing
        });
    },
  },
};
